import React, { useEffect, useState } from "react";
import "hes-gallery/dist/hes-gallery.css";
import HesGallery from "hes-gallery";
import "../../Css/Fourthconvo.css";

const Fourthdconvo = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(
          "https://api.gkaglobal.org/gkawebsite/gallery.php?year=2002"
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        

        if (
          Array.isArray(data) &&
          data.length > 0 &&
          Array.isArray(data[0].images)
        ) {
          setImages(data[0].images);
        } else {
          console.error("Unexpected API response format:", data);
          setError("No valid image data found in the response.");
        }
      } catch (error) {
        console.error("Error fetching images:", error);
        setError("Failed to load images. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    if (images.length > 0) {
      setTimeout(() => {
        HesGallery.init({
          wrap: true,
          showImageCount: true,
          disableScrolling: false,
          imgSrcAttr: "src",
        });
      }, 500);
    }
  }, [images]);

  return (
    <>
      <h1 className="tor">2002 Toronto</h1>
      <div className="hes-gallery">
        {loading ? (
          <p className="p3">Loading images...</p>
        ) : error ? (
          <p className="p3">{error}</p>
        ) : images.length > 0 ? (
          images.map((image, index) => (
            <img
              key={index}
              src={"https://api.gkaglobal.org/" + image}
              data-fullsize={"https://api.gkaglobal.org/" + image}
              className="gallery-img3"
              alt="Gallery"
              onError={(e) => (e.target.style.display = "none")}
            />
          ))
        ) : (
          <p className="p3">No images available.</p>
        )}
      </div>
    </>
  );
};

export default Fourthdconvo;
